"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montecatini-val-di-cecina": {
    "8b96c34d": [{
      "hkey": "054fd523",
      "slug": "montecatini-val-di-cecina",
      "name": "Montecatini Val di Cecina",
      "primary": true,
      "skipSearch": false
    }],
    "buriano": [{
      "hkey": "054fd523",
      "slug": "montecatini-val-di-cecina",
      "name": "Montecatini Val di Cecina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6ab58165": [{
      "hkey": "054fd523",
      "slug": "montecatini-val-di-cecina",
      "name": "Montecatini Val di Cecina",
      "primary": true,
      "skipSearch": false
    }],
    "gello": [{
      "hkey": "054fd523",
      "slug": "montecatini-val-di-cecina",
      "name": "Montecatini Val di Cecina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;